function ghd_themeCheck() {
  var theme = localStorage.getItem("ghd-theme");

  if ( theme ) {
    $('body').addClass('ghd-theme-' + theme );
    // console.log('THEME FOUND: ' + theme );
  }
}

function ghd_themeUpdate(theme) {
  $('body').removeClass('ghd-theme-dark ghd-theme-light').addClass( theme );
  localStorage.setItem("ghd-theme", theme.replace('ghd-theme-', '') );
}


function init() {

  ghd_themeCheck();

  // Update GHD Theme on click
  if ($('a[href*="ghd-theme"]').length > 0) {
    $('a[href*="ghd-theme"]').on('click', function(e) {
      var theme = $(this).attr('href').replace('#', '');

      ghd_themeUpdate(theme);
      e.preventDefault();
    });
  }

  // Match media OSX Prefers Color Scheme 
  // ! Need listener for macOS update
  // if (window.matchMedia('(prefers-color-scheme: dark)') ) {
  //   ghd_themeUpdate('ghd-theme-dark');
  // }
  // if (window.matchMedia('(prefers-color-scheme: light)') ) {
  //   ghd_themeUpdate('ghd-theme-light');
  // }
    
}

module.exports = { init };